import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

import { CompanyService }    from '../../app-lite/companies/company.service';
import { SessionService } from '../../app-lite/sessions/session.service';

@Component({
  template: require('./mechanic.actions.component.html')
})
export class MechanicActionsComponent {
  @Input() record: any;

  @Output() onEditClick      : EventEmitter<any> = new EventEmitter();
  @Output() onMobileUserClick: EventEmitter<any> = new EventEmitter();
  @Output() onSMSClick       : EventEmitter<any> = new EventEmitter();
  @Output() onActivateClick  : EventEmitter<any> = new EventEmitter();

  constructor (
    public companyService : CompanyService,
    public sessionService : SessionService
  ) {}
}
